import React from 'react';
import {Checkbox, Form, Icon, Input, Radio, Select} from 'antd';

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>Consent Process - REGAINED CAPACITY CONSENT FORM</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> :
          <div>
            <h4 align="center">INFORMATION AND CONSENT FORM</h4>
            <h4 align="center">Surrogate Deferred Consent and Regained Capacity following Deferral of Consent
              Process</h4>
            <h4>TITLE:&nbsp;&nbsp;&nbsp; Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research
              Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)</h4>
            <p><b>Principal Investigator:</b> Dr. Brian Buck</p>
            <p><b>Co-Investigators:</b> Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr.
              Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali
              Nomani</p>

            <p>Because your illness made it impossible for you to participate fully in the informed consent process,
              consent to participate in this research study was obtained via deferred consent from a physician. Your
              physician believed it was in your best interest clinically to participate in this research. The
              administration of either Alteplase or Tenecteplase cannot be undone.</p>

            <p>Informed consent is essential throughout a research study. This means in your situation, you are now
              being given the opportunity to agree or disagree with the decision made by your physician or substitute
              decision maker for you to participate. A member of the study team will go over the Information and Consent
              Form signed on your behalf, and answer all of your questions about the study.</p>

            <p>If you agree to stay in the study, please sign below. If you do not agree, tell the study staff so that
              all data already collected about you will be destroyed.</p>

            <p>If you have questions or concerns about your rights as a study participant, you may contact the Research
              Ethics Office, at 780-492-2615. This office is independent of the researchers.</p>
          </div>}
        <p><strong>Server Date (UTC): {props.consentDate || props.date}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        {(props.consentMethodType !== 'EmailRegainedCapacity' || props.token) && <Form.Item>
          <div className='form-label'>Please select consent option below:</div>
          {props.form.getFieldDecorator('rccf_option', {
            initialValue: false,
            valuePropName: 'checked'
          })(
            <Checkbox>I wish to remain in the study. I have reviewed the information and consent form
              originally signed on my behalf, and my questions have been answered.</Checkbox>
          )}
        </Form.Item>}

        <Form.Item>
          <div className='form-label'>Participant’s Name</div>
          {props.form.getFieldDecorator('rccf_participant_name', {
            initialValue: props.rccf_participant_name,
            rules: [{
              required: true,
              message: 'Please enter the Participant\'s full name'
            }],
          })(
            <Input
              prefix={<Icon type="user" style={{color: '#eee'}}/>}
              placeholder="Participant Full Name"
              autoFocus
            />
          )}
        </Form.Item>

        {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
          {props.form.getFieldDecorator('rccf_participant_email', {
            initialValue: props.rccf_participant_email,
            rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
          })(
            <Input disabled={props.token} placeholder="Participant Email"/>
          )}
        </Form.Item>}

        <Form.Item>
          <div className='form-label'>Investigator/Delegate’s Name</div>
          {props.form.getFieldDecorator('rccf_investigator_name', {
            initialValue: props.rccf_investigator_name,
            rules: [{
              required: true,
              message: 'Please enter the Investigator/Delegate\'s full name'
            }],
          })(
            <Input
              disabled={props.token}
              prefix={<Icon type="user" style={{color: '#eee'}}/>}
              placeholder="Investigator/Delegate Full Name"
            />
          )}
        </Form.Item>

        {(props.consentMethodType !== 'EmailRegainedCapacity' || props.token) && <Form.Item>
          <label>
            <div className='form-label'>Do you consent to the terms described above?</div>
            {props.form.getFieldDecorator('consent_provided', {
              rules: [{
                required: true,
                message: 'Do you consent to the terms described above?'
              }],
            })(
              <Select>
                <Option value="yes">Yes</Option>
                <Option value="">No</Option>
              </Select>
            )}
          </label>
        </Form.Item>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLethbridge/Step3aRegainedCapacity.js